import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=bc320534&scoped=true&"
import script from "./ContactsView.vue?vue&type=script&lang=js&"
export * from "./ContactsView.vue?vue&type=script&lang=js&"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=bc320534&prod&lang=scss&"
import style1 from "./ContactsView.vue?vue&type=style&index=1&id=bc320534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc320534",
  null
  
)

export default component.exports